import styled from 'styled-components';

export const Testimony = styled.div`
  gap: 16px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: 4vh;
  max-width: 472px;
  padding: 16px 24px;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  background: #FFF5E6;
  border-radius: 8px;
  @media(max-width: 1190px) {
    max-width: 400px;
  }
  @media (max-width: 700px) {
    max-width: 100%;
  }
`

export const TestimonyNew = styled.div`
  gap: 16px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: 4vh;
  max-width: 472px;
  padding: 16px 24px;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  background: #e6e6e6;
  border-radius: 8px;
  @media(max-width: 1190px) {
    max-width: 400px;
  }
  @media (max-width: 700px) {
    max-width: 100%;
  }
`

export const Text = styled.div`
  font-size: 16px;
  color: #2B323B;
  font-weight: 400;
  font-style: normal;
  text-align: center;
  font-family: 'Proxima Nova';
`

export const CardPlayer = styled.div`
  display: flex;
  align-items: center;
  @media(max-width: 1190px) {
    margin-top: 16px;
  }
  @media (max-width: 700px) {
    margin-top: 0;
  }
  @media(max-width: 474px) {
    margin-top: 16px;
  }
`

export const PlayerImg = styled.img`
  border-radius: 50%;
  object-fit: fixed;
  height: 44px;
  width: 44px;
  left: 112px;
  top: 0px;
`

export const PlayerInfo = styled.div`
  display: flex;
  margin-left: 11px;
  flex-direction: column;
`

export const PlayerName = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.02em;
  color: #2B323B;
`

export const PlayerPosition = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #38424D;
`
